import React from "react"

export default function PeopleIcon() {
  return (
    <svg
      width="61"
      height="60"
      viewBox="0 0 61 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        className="stroke-white"
        cx="24"
        cy="18"
        r="10"
        stroke="#4996FF"
        strokeWidth="4"
      />
      <circle cx="44.2425" cy="31.4545" r="7.27273" fill="#B9D7FF" />
      <path
        className="white-fill"
        d="M21 37H27C28.1998 37 29.3705 37.1243 30.5 37.3607C32.784 37.8387 34 34.0874 32 33.5989C30.3976 33.2075 28.723 33 27 33H21C10.7698 33 2.24821 40.3151 0.380493 50C0.130771 51.2949 0 52.6322 0 54H22C24 54 24 50 22 50H4.47326C6.27207 42.5413 12.9889 37 21 37Z"
        fill="#4996FF"
      />
      <path
        d="M30 54.3333C30 46.9695 35.9695 41 43.3333 41H46.9697C54.3335 41 60.303 46.9695 60.303 54.3333H30Z"
        fill="#B9D7FF"
      />
    </svg>
  )
}
